<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isMobile } from "@/utils";

export default {
  name: "App",
  mounted() {
    if (isMobile() && this.$route.meta.type !== "m") {
      this.$router.replace("/m");
    }
    window.onresize = () => {
      if (isMobile()) {
        if(this.$route.meta.type !== "m"){
          this.$router.replace("/m");
        }
      } else {
        //展示移动端
        if ((document.body.clientWidth <= 768 && this.$route.meta.type === "pc")) {
          this.$router.replace(this.$route.meta.url);
        }
        //展示桌面端
        if (document.body.clientWidth > 768 && this.$route.meta.type === "m") {
          this.$router.replace(this.$route.meta.url);
        }
      }
    }
  },
};

(function flexible(window, document) {
  var docEl = document.documentElement;
  var dpr = window.devicePixelRatio || 1;

  // adjust body font size
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = 12 * dpr + "px";
    } else {
      document.addEventListener("DOMContentLoaded", setBodyFontSize);
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit() {
    var rem = docEl.clientWidth / 7.75;
    docEl.style.fontSize = rem + "px";
  }

  setRemUnit();

  // reset rem unit on page resize
  window.addEventListener("resize", setRemUnit);
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      setRemUnit();
    }
  });

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement("body");
    var testElement = document.createElement("div");
    testElement.style.border = ".5px solid transparent";
    fakeBody.appendChild(testElement);
    docEl.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      docEl.classList.add("hairlines");
    }
    docEl.removeChild(fakeBody);
  }
})(window, document);

</script>

<style lang="less">
@import "styles/common.less";
</style>



// WEBPACK FOOTER //
// src/App.vue